<template>
  <v-container id="reference-term-list">
    <v-row>
      <v-col cols="8" md="8" class="breadcrumbs">
        <v-breadcrumbs :items="breadcrumbs" :large="true" :divider="'>'">
        </v-breadcrumbs>
      </v-col>

      <v-col cols="4" sm="4">
        <div class="text-right">
          <div cols="10" md="1">
            <app-modal-import-solution
              :color="'success'"
              :icon="'mdi-plus-circle'"
              @onSave="$emit('reloadSolutions')"
              :possuiMunicipio="true"
              v-if="isFullAdmin"
            >
              <template v-slot:title>
                Exportação de
                {{ isAT ? "Iniciativas" : isGov ? "Fases" : "Solução" }}
              </template>
            </app-modal-import-solution>
            <app-modal-insert-solution
              :edit="false"
              :color="'success'"
              :icon="'mdi-plus-circle'"
              :filter="filter"
              :groupSolutionId="groupSolutionIds"
              @onSave="$emit('reload')"
            >
              <template v-slot:title>
                Cadastrar
                {{ isAT ? "Iniciativa" : isGov ? "Fases" : "Solução" }}
              </template>
            </app-modal-insert-solution>
          </div>
        </div>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="solutions"
          item-key="name"
          class="elevation-1"
        >
          <template v-slot:item.descricao="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <div v-bind="attrs" v-on="on">
                  {{ diminuirValue(item.descricao) }}
                </div>
              </template>
              <div style="max-width: 500px">{{ item.descricao }}</div>
            </v-tooltip>
          </template>
          <template v-slot:item.acoes="{ item }">
            <v-row>
              <v-col cols="1">
                <app-modal-insert-solution
                  :object="item"
                  :edit="true"
                  :color="'warning'"
                  :icon="'mdi-pencil'"
                  :filter="filter"
                  @onSave="$emit('reload')"
                >
                  <template v-slot:title>
                    Edição de
                    {{ isAT ? "Iniciativa" : isGov ? "Fases" : "Solução" }}
                  </template>
                </app-modal-insert-solution>
              </v-col>
            </v-row>
          </template>

          <template v-slot:item.acoes_delete="{ item }">
            <v-row>
              <v-col cols="1">
                <app-modal-delete-solution
                  :payload="item"
                  @onDelete="$emit('reload')"
                >
                  <template v-slot:title>
                    Deletar
                    {{ isAT ? "Iniciativa" : isGov ? "Fases" : "Solução" }}
                  </template>
                </app-modal-delete-solution>
              </v-col>

              <v-col cols="1"> </v-col>
            </v-row>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import AppModalInsertSolution from "./ModalInsert";
import AppModalDeleteSolution from "./ModalDelete";
import { mapActions, mapGetters } from "vuex";
import AppModalImportSolution from "@/modules/solution/components/city/ModalImport";

export default {
  name: "AppSolutionList",
  props: {
    filter: { type: Object, required: true },
    solutions: { type: Array, required: true },
    groupSolutionId: "",
  },
  components: {
    AppModalInsertSolution,
    AppModalDeleteSolution,
    AppModalImportSolution,
  },
  watch: {
    groupSolutionId(item) {
      this.groupSolutionIds = item;
    },
  },
  mounted() {
    this.headers = [
      {
        text: "#",
        value: "solucaoId",
        sortable: false,
        width: "5%",
      },
      {
        text: this.isAT
          ? "Grupo de Iniciativa"
          : this.isGov
          ? "Grupo de Fase"
          : "Grupo de Solução",
        value: "grupoSolucao.nome",
        width: "30%",
      },
      {
        text: this.isAT ? "Iniciativa" : this.isGov ? "Fase" : "Solução",
        align: "left",
        value: "nome",
        width: "30%",
      },
      {
        text: "Descrição",
        value: "descricao",
        width: "20%",
      },

      { text: "Editar", value: "acoes", sortable: false },
      { text: "Excluir", value: "acoes_delete", sortable: false },
    ];

    this.groupSolutionIds = this.filter.grupoSolucaoId;
  },
  data() {
    return {
      headers: [],
      breadcrumbs: [
        {
          text: "Grupos de Soluções",
          disabled: true,
          href: "termo-referencia",
        },
        {
          text: "Soluções",
          disabled: true,
          href: "termo-referencia",
        },
      ],
      groupSolutionIds: null,
    };
  },
  computed: {
    ...mapGetters(["loading", "isAT", "isFullAdmin", "isGov"]),
  },
  methods: {
    ...mapActions(["setLoading"]),

    diminuirValue(item) {
      if (item && item.length > 20) {
        return item.substring(0, 20) + "...";
      }

      return item;
    },
  },
};
</script>

<style lang="scss">
@import "./style.scss";
</style>
